// Settings cache for instant loading
const SETTINGS_CACHE_KEY = 'skb_settings_cache';
const CACHE_EXPIRY = 24 * 60 * 60 * 1000; // 24 hours (increased for better persistence)

// Hospital logo URL (permanent)
const HOSPITAL_LOGO = 'https://customer-assets.emergentagent.com/job_618059af-3e30-4212-9ad8-fc0d3ff3fc28/artifacts/ychm2ehn_images.jpeg';

// Complete default settings - These will ALWAYS be available even if database is empty
export const DEFAULT_SETTINGS = {
  // Hospital Identity (PERMANENT - will not change)
  hospital_name_en: 'SKB Aarogyam Super Speciality Healthcare (Hospital)',
  hospital_name_hi: 'एसकेबी आरोग्यम सुपर स्पेशलिटी हेल्थकेयर (अस्पताल)',
  logo_url: HOSPITAL_LOGO,
  
  // Typography settings
  header_font_size: 14,
  footer_font_size: 16,
  hospital_name_word_styles: [
    { word: 'SKB', index: 0, color: '#f97316', font: 'Georgia, serif', fontWeight: '700' },
    { word: 'Aarogyam', index: 1, color: '#f97316', font: 'Georgia, serif', fontWeight: '700' },
    { word: 'Super', index: 2, color: '#1e40af', font: 'Georgia, serif', fontWeight: '700' },
    { word: 'Speciality', index: 3, color: '#1e40af', font: 'Georgia, serif', fontWeight: '700' },
    { word: 'Healthcare', index: 4, color: '#1e40af', font: 'Georgia, serif', fontWeight: '700' },
    { word: '(Hospital)', index: 5, color: '#1e40af', font: 'Georgia, serif', fontWeight: '700' },
  ],
  
  // Contact Information (PERMANENT defaults)
  phone: '9876543210',
  whatsapp: '9876543210',
  email: 'info@skbaarogyam.com',
  appointment_whatsapp: '9876543210',
  whatsapp_message: 'Hi, I want to enquire about the services',
  appointment_message: 'I want to enquire for an appointment',
  
  // Address (PERMANENT)
  address_en: '3rd KM, SKB Aarogyam, Jansath Road, Near Stepping Stones School, Muzaffarnagar, Uttar Pradesh 251001',
  address_hi: '3 किमी, एसकेबी आरोग्यम, जानसठ रोड, स्टेपिंग स्टोन्स स्कूल के पास, मुजफ्फरनगर, उत्तर प्रदेश 251001',
  plus_code: '8HRG+6X Muzaffarnagar, Uttar Pradesh',
  
  // Map coordinates
  map_lat: 29.4726,
  map_lng: 77.7085,
  
  // Images
  // NOTE: do NOT default homepage_image_url to a hardcoded stock photo — that caused the
  // hero to flash an old Unsplash image for ~10s on first load before the admin-saved
  // image arrived from the API. Leave empty so the hero renders blank/loading state
  // until the real settings are fetched (and from then on are served instantly from cache).
  homepage_image_url: '',
  
  // AI Chatbot
  ai_agent_enabled: true,
  chatbot_name: 'SKB Aarogyam Assistant',
  chatbot_avatar_url: 'https://customer-assets.emergentagent.com/job_3054feee-f687-43e1-8d9a-d6a39a8a5e2c/artifacts/znxwixk7_1775152500403.png',
  
  // Homepage Stats (PERMANENT defaults)
  stat_happy_patients: '10,000+',
  stat_happy_patients_label_en: 'Happy Patients',
  stat_happy_patients_label_hi: 'खुश मरीज',
  stat_expert_doctors: '25+',
  stat_expert_doctors_label_en: 'Expert Doctors',
  stat_expert_doctors_label_hi: 'विशेषज्ञ डॉक्टर',
  stat_specialties: '15+',
  stat_specialties_label_en: 'Specialties',
  stat_specialties_label_hi: 'विशेषताएँ',
  stat_emergency: '24/7',
  stat_emergency_label_en: 'Emergency',
  stat_emergency_label_hi: 'आपातकालीन',
};

// Get cached settings or defaults
// IMPORTANT: hero media (image/video) URLs are intentionally NOT served from cache —
// they're stripped on read so the hero never flashes a stale image while the API
// loads the latest one. Everything else (text, contact, theme) is fine to cache.
export const getCachedSettings = () => {
  try {
    const cached = localStorage.getItem(SETTINGS_CACHE_KEY);
    if (cached) {
      const { data } = JSON.parse(cached);
      const fresh = { ...data };
      delete fresh.homepage_image_url;
      delete fresh.homepage_video_url;
      delete fresh.homepage_video_url_480;
      delete fresh.homepage_media_type;
      return { ...DEFAULT_SETTINGS, ...fresh };
    }
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Failed to read settings cache:', e);
    }
  }
  return DEFAULT_SETTINGS;
};

// Save settings to cache
export const cacheSettings = (settings) => {
  try {
    localStorage.setItem(SETTINGS_CACHE_KEY, JSON.stringify({
      data: settings,
      timestamp: Date.now()
    }));
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Failed to cache settings:', e);
    }
  }
};

// Check if cache is fresh
export const isCacheFresh = () => {
  try {
    const cached = localStorage.getItem(SETTINGS_CACHE_KEY);
    if (cached) {
      const { timestamp } = JSON.parse(cached);
      return Date.now() - timestamp < CACHE_EXPIRY;
    }
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('isCacheFresh check failed:', e);
    }
  }
  return false;
};

// Preload critical images
export const preloadImages = (urls) => {
  urls.forEach(url => {
    if (url) {
      const img = new Image();
      img.src = url;
    }
  });
};
